import { translate } from "@escapio/shared/l10n/translate";
import { hasEscapioRate } from "@escapio/portal/state/escapio-deals-helpers";

export const NORMAL = "normal";
export const TOP = "top";

export function getRecommendationText(type, hotel) {
	return hasEscapioRate(hotel)
		? translate("hotel_recommendation_escapio_offer")
		: type === TOP
			? translate("top_hotel_our_recommendation")
			: null;
}
